import React, { useState } from 'react'
import moment from 'moment'

import { DateRange } from 'react-date-range'
import { connect } from 'react-redux'
import {
  useHistory,
  withRouter,
} from 'react-router-dom'
import {
  setReportsToDealers,
  fetchJobById,
  fetchJobs,
  getOrders,
  redirectToVariance,
  updateJob,
} from '../../store/actions'

import BaseModal from '../BaseModal'
import ButtonPrimary from '../ui/ButtonPrimary'
import ButtonTransparent from '../ui/ButtonTransparent'

import './index.css'

const DatePickerReports = (props) => {
  let history = useHistory()

  const [ range, setRange ] = useState({
    label: 'Today',
    startDate: moment(),
    endDate: moment(),
  })
  const handleSelect = (range) => {
    setRange({ ...range, label: `${range.startDate.format('MM/DD')} - ${range.endDate.format('MM/DD')}` })
  }
  console.log('props',props)

  const fastSelect = (when) => {
    let date
    switch (when) {
      case 'Yesterday':
      default:
        date = {
          startDate: moment().subtract(1, 'days'),
          endDate: moment().subtract(1, 'days'),
        }
        break
      case 'Today':
        date = {
          startDate: moment(),
          endDate: moment(),
        }
        break
      case 'Tomorrow':
        date = {
          startDate: moment().add(1, 'days'),
          endDate: moment().add(1, 'days'),
        }
        break
      case 'last 7 days':
        date = {
          startDate: moment().subtract(7, 'days'),
          endDate: moment(),
        }
        break
      case 'last month':
        date = {
          startDate: moment().subtract(1, 'months'),
          endDate: moment(),
        }
        break
    }
    ///ADDED ACTION CREATOR


    console.log(date.endDate.format('YYYY-MM-DD'))
    console.log(date.startDate.format('YYYY-MM-DD'))
  }


  const createDateForReports = () => {
    const { endDate, startDate }= range;
    const { params } = props.match;

    let page = params.jobId ? 'jobs' : params.dealerId ? 'dealers' : params.employeeId ? 'employees' : 'generic';

    let id = params.jobId || params.dealerId || params.employeeId || 'general';

    if(props.reportType === 'uuid_and_time_range') {
      props.setReportsToDealers(props.reportName, {
        uuid: id,
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD')
      })
    } else {
      props.setReportsToDealers(props.reportName, {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD')
      })
    }

    console.log(`/${page}/${id}/reports/${props.reportName}`)
    history.push(`/${page}/${id}/reports/${props.reportName}`)
  }

  console.log('reportType',props.reportType)
  const body = (
    <div className="date-picker__body">
      <DateRange
        onChange={handleSelect}
      />
      <div className="date-picker__fast-select fast-select">
        <p className="fast-select__title">Fast Select</p>
        <ul className="fast-select__list">
          <li className="fast-select__item" onClick={() => fastSelect('Yesterday')}>Yesterday</li>
          <li className="fast-select__item" onClick={() => fastSelect('Today')}>Today</li>
          <li className="fast-select__item" onClick={() => fastSelect('Tomorrow')}>Tomorrow</li>
          <li className="fast-select__item" onClick={() => fastSelect('last 7 days')}>last 7 days</li>
          <li className="fast-select__item" onClick={() => fastSelect('last month')}>last month</li>
        </ul>
      </div>
    </div>
  )

  const footerForReports = (
    <div className="date-picker__footer">
      <ButtonPrimary onClick={createDateForReports} name={'View Report'} />
    </div>
  )

  return (
    <BaseModal
      onClose={props.toggleModal}
      body={body}
      footer={footerForReports}
    />
  )
}
// setReportsToDealers

const mapStateToProps = (state) => ({
  // jobReports: state.reports.jobReports,
  // dealerReports: state.reports.reports.dealer_report,
  // employeeReports: state.reports.reports.user_report,
  // listJobReports: state.reports.jobReports,
  // listDealerReports: state.reports.dealersReports,
  // listUserReports: state.reports.userReports,
  // startDateReport: state.reports.startDateReport,
  // endDateReport: state.reports.endDateReport
})

const mapDispatchToProps =
  {
    setReportsToDealers,
  }

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DatePickerReports))
